/**
 * The Nexdel brand mark (icon + wordmark lockup), served from the CDN.
 * Same asset used in transactional emails so branding stays consistent.
 * The logo is white, intended for dark backgrounds (login / invite heroes).
 */
const LOGO_URL =
  'https://res.cloudinary.com/daeow0wv5/image/upload/v1781102852/nexdel_logo_hgthj4.png';

interface BrandLogoProps {
  /** Tailwind sizing/utility classes for the <img>. Defaults to a medium height. */
  className?: string;
}

export function BrandLogo({ className = 'h-16 w-auto' }: BrandLogoProps) {
  return <img src={LOGO_URL} alt="NexDel" className={className} />;
}
